import { render } from "./OrderResults.vue?vue&type=template&id=4a4eeef8"
import script from "./OrderResults.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderResults.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/codebuild/output/src3003388635/src/git-codecommit.ap-northeast-1.amazonaws.com/v1/repos/portal-dev-frontend/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/components/templates/orderResults/OrderResults.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4a4eeef8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4a4eeef8', __exports__)) {
    console.log('reload')
    api.reload('4a4eeef8', __exports__)
  }
  
  module.hot.accept("./OrderResults.vue?vue&type=template&id=4a4eeef8", () => {
    console.log('re-render')
    api.rerender('4a4eeef8', render)
  })

}


export default __exports__